module.exports = __webpack_public_path__ + "img/profile.93aa99a8.svg";